import { createContext, useContext, useEffect, type ReactNode } from "react";
import type { WherdClient } from "../client";

const WherdContext = createContext<WherdClient | null>(null);

// Core provider — takes a pre-built client (the platform packages build it with
// their own storage/device/shake adapters and wrap this).
export function WherdCoreProvider({
  client,
  children,
}: {
  client: WherdClient;
  children: ReactNode;
}) {
  useEffect(() => {
    let active = true;
    client
      .init()
      .then(() => {
        // Open the live (SSE) connection once identity + anonymousId are ready.
        if (active) client.subscribeLive();
      })
      .catch(() => {
        // init failures are non-fatal; the SDK still works pull-only.
      });
    return () => {
      active = false;
      client.disconnectLive();
    };
  }, [client]);

  return <WherdContext.Provider value={client}>{children}</WherdContext.Provider>;
}

export function useWherdClient(): WherdClient {
  const ctx = useContext(WherdContext);
  if (!ctx) {
    throw new Error("Wherd hooks must be used within <WherdProvider>");
  }
  return ctx;
}
